module.exports = __webpack_public_path__ + "img/1961da5618b62a73bc7134262716956e.png";